// extracted by mini-css-extract-plugin
export default {"Page":"Page_Page__G6S7W","PrintPage":"Page_PrintPage__w4QuN","SafariPrintPage":"Page_SafariPrintPage__pkmpJ"};